import api from "@/lib/api";

export const faqService = {
  list: (q = "") => api.get("/faq", { params: { q } }).then((r) => r.data.entries),
  ask: (question) => api.post("/faq/ask", { question }).then((r) => r.data.entry),
  pin: (id) => api.post(`/faq/${id}/pin`).then((r) => r.data),
  narrate: (id) => api.post(`/faq/${id}/narrate`).then((r) => r.data),
  remove: (id) => api.delete(`/faq/${id}`).then((r) => r.data),
};
